import omit from 'lodash.omit';

import { Model, ModelData } from 'src/containers/ProjectDiagram/types/model';
import { removeAttributeIrisFromMappings } from 'src/containers/ProjectDiagram/utils/mapping/removeAttributeIrisFromMappings';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

export const removeDomainFromAttributeModelData =
  ({ value, domain }: { value: string; domain: string }) =>
  (model: Model) => {
    const existingAttributeModelData = model.modelData.attributesByIri[value];

    if (!existingAttributeModelData) {
      return;
    }

    removeAttributeIrisFromMappings(model, value, domain);

    // Remove the class from the attribute's domain
    setDataProperty<ModelData>(model)(model.modelData, 'attributesByIri', {
      ...model.modelData.attributesByIri,
      [value]: {
        ...existingAttributeModelData,
        domains: omit(existingAttributeModelData.domains, [domain]),
      },
    });
  };
